import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar/Sidebar';
import Login from './apps/tickets/pages/Auth/Login';
import Register from './apps/tickets/pages/Auth/Register';
import ResetPassword from './apps/tickets/pages/Auth/ResetPassword';
import NewPassword from './apps/tickets/pages/Auth/NewPassword';
import AdminDashboard from './apps/tickets/pages/Dashboard/AdminDashboard';
import AssetManagerDashboard from './apps/tickets/pages/Dashboard/AssetManagerDashboard';

import ProtectedRoute from './apps/tickets/routes/ProtectedRoute';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Layout wrapper component
import { DashboardCommon } from './apps/tickets/pages/Dashboard/DashboardCommon';
import "react-toastify/dist/ReactToastify.css";
import Customers from './apps/tickets/pages/Dashboard/Customer_Manager/Customers';
import Offers from './apps/tickets/pages/Dashboard/Customer_Manager/Offers';
import CreateAssetPage from './components/common/CreateAssetPage';
import EditAssetPage from './components/common/EditAssetPage';
import CreateCustomerPage from './components/common/CreateCustomerPage';
import UpdateCustomerPage from './components/common/UpdateCustomerPage';
import CreateFinanceAssetPage from './components/common/CreateFinanceAssetPage';
import EditFinanceAssetPage from './components/common/EditFinanceAssetPage';
import UpdateOfferPage from './components/common/UpdateOfferPage';
import CreateOfferPage from './components/common/CreateOfferPage';
import CreateWarehousePage from './components/common/CreateWarehousePage';
import UpdateWarehousePage from './components/common/UpdateWarehousePage';
import HomePage from './apps/tickets/pages/Auth/HomePage';
import EditAssetPageNew from './components/common/EditAssetPageNew';
import ViewWarehouse from './components/common/ViewWarehouse';
import GanttChart from './components/GanttChart';
import ForkliftDetailView from './components/ForkliftDetailView';
import OtpVerification from './apps/tickets/pages/Auth/OtpVerification';
import TransportOrderPage from './components/assets_type/TransportOrderPage';
import TagManager from 'react-gtm-module';
import CookiePreferenceModal from './components/Cookie';
import Footer from './SharedComponent/Footer/Footer';
import CookieBanner from './components/CookieBanner';
import ContactPage from './components/contact';
import TermsandCondition from './SharedComponent/Footer/TermsandCondition';
import LegalNotice from './SharedComponent/Footer/LegalNotice';
import DataProcessing from './SharedComponent/Footer/DataProcessing';
import PrivacyPolicy from './SharedComponent/Footer/PrivacyPolicy';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GT
};
console.log("GOOGLE TAG MANAGER",process.env.REACT_APP_GT)

const Layout = ({ children, onCookiePreferencesClick }) => {
  const location = useLocation();
  const isLoggedIn = localStorage.getItem('access') !== null;
  const isAuthPage = ['/login', '/register', '/reset-password', '/'].includes(location.pathname);

  return (
    <div className="app">
      {isLoggedIn && !isAuthPage && <Navbar />}
      <main className={`main-content ${!isLoggedIn || isAuthPage ? 'auth-page' : ''}`}>
        {children}
      </main>
      {/* Always show footer */}
      <Footer onCookiePreferencesClick={onCookiePreferencesClick} />
    </div>
  );
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showCookieModal, setShowCookieModal] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [isGtmInitialized, setIsGtmInitialized] = useState(false);

 const initializeGtm = () => {
    if (!isGtmInitialized) {
      TagManager.initialize(tagManagerArgs);
      setIsGtmInitialized(true);
      console.log('GTM initialized');
    }
  };
  
  const disableGtm = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'consent_update',
        'analytics_storage': 'denied'
      });
      console.log("GTM analytics storage denied.");
  };

  useEffect(() => {
    const prefs = localStorage.getItem('cookiePrefs');
    if (!prefs) {
      setShowCookieBanner(true);
    } else {
      const parsed = JSON.parse(prefs);
      if (parsed.analytics) {
        initializeGtm();
      }
    }
  }, []);

  const handleSaveCookiePreferences = (prefs) => {
    const currentPrefs = localStorage.getItem('cookiePrefs');
    const wasAnalyticsEnabled = currentPrefs ? JSON.parse(currentPrefs).analytics : false;

    localStorage.setItem('cookiePrefs', JSON.stringify(prefs));
    setShowCookieModal(false);

    if (prefs.analytics) {
        if(!wasAnalyticsEnabled) {
            setTimeout(() => window.location.reload(), 300);
        } else {
            initializeGtm();
        }
    } else {
        disableGtm();
    }
  };

  const handleAcceptAll = () => {
    const prefs = { analytics: true };
    localStorage.setItem('cookiePrefs', JSON.stringify(prefs));
    initializeGtm();
    setShowCookieBanner(false);
  };

  const handleNecessaryOnly = () => {
    const prefs = { analytics: false };
    localStorage.setItem('cookiePrefs', JSON.stringify(prefs));
    disableGtm();
    setShowCookieBanner(false);
  };
  
  const handleSettings = () => {
    setShowCookieBanner(false);
    setShowCookieModal(true);
  };

  const handleShowCookieSettings = () => {
    setShowCookieModal(true);
  };


  return (
    <>
      <Router>
        <Layout onCookiePreferencesClick={handleShowCookieSettings}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-otp" element={<OtpVerification />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path='/terms-and-conditions' element={<TermsandCondition/>}/>
            <Route path="/legal-notice" element={<LegalNotice/>}/>
            <Route path="/data-processing" element={<DataProcessing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/reset-password/:uidb64/:token" element={<NewPassword />} />
            <Route path="/transport-order/:id" element={<TransportOrderPage />} />
            <Route path='/dashboard' element={<ProtectedRoute><DashboardCommon/></ProtectedRoute>}/>
            <Route path='/dashboard/offers' element={<ProtectedRoute><Offers /></ProtectedRoute>}/>
            
            <Route path="/create-asset" element={<ProtectedRoute><CreateAssetPage /></ProtectedRoute>} />
            <Route path="/utilization-report" element={<ProtectedRoute><GanttChart /></ProtectedRoute>} />
            <Route path="/edit-asset/:id" element={<ProtectedRoute><EditAssetPage /></ProtectedRoute>} />
            <Route path="/edit-asset-new/:id" element={<ProtectedRoute><EditAssetPageNew /></ProtectedRoute>} />
            <Route path="/create-customer" element={<ProtectedRoute><CreateCustomerPage /></ProtectedRoute>} />
            <Route path="/update-customer/:id" element={<ProtectedRoute><UpdateCustomerPage /></ProtectedRoute>} />
            <Route path="/create-finance-asset/:id" element={<ProtectedRoute><CreateFinanceAssetPage /></ProtectedRoute>} />
            <Route path="/update-finance-asset" element={<ProtectedRoute><EditFinanceAssetPage /></ProtectedRoute>} />
            <Route path="/update-offer/:id" element={<ProtectedRoute><UpdateOfferPage /></ProtectedRoute>} />
            <Route path="/create-offer" element={<ProtectedRoute><CreateOfferPage /></ProtectedRoute>} />
            {/* warehouse */}
            <Route path="/create-warehouse" element={<ProtectedRoute><CreateWarehousePage /></ProtectedRoute>} />
            <Route path="/update-warehouse/:id" element={<ProtectedRoute><UpdateWarehousePage /></ProtectedRoute>} />
            <Route path="/warehouse/:id" element={<ProtectedRoute><ViewWarehouse /></ProtectedRoute>} />
            <Route path="/asset-detail-view/:id" element={<ProtectedRoute><ForkliftDetailView /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/contact" element={<ContactPage />} />

          </Routes> 
        </Layout>
      </Router>
      {showCookieBanner && (
        <CookieBanner
          onAcceptAll={handleAcceptAll}
          onNecessaryOnly={handleNecessaryOnly}
          onSettings={handleSettings}
        />
      )}

      <CookiePreferenceModal
        show={showCookieModal}
        onClose={() => setShowCookieModal(false)}
        onSave={handleSaveCookiePreferences}
      />
    </>
  );
};

export default App;
